import { Heading } from "components/common/Heading";
import {
  EXTEND_TERM_SCREEN_HEADING,
  EXTEND_TERM_SCREEN_SUBHEADING_1,
  EXTEND_TERM_SCREEN_SUBHEADING_2,
  EXTEND_TERM_SCREEN_SUBHEADING_3,
} from "./ExtendTerm.const";

export const ExtendTermHeader = () => (
  <div className="header">
    <Heading className="screen-header" title={EXTEND_TERM_SCREEN_HEADING}>
      <div className="main-paragraph">
        <strong>{EXTEND_TERM_SCREEN_SUBHEADING_1}</strong>
        <span className="double-line-break">
          {EXTEND_TERM_SCREEN_SUBHEADING_2}
        </span>
        <span className="double-line-break">
          <strong>{EXTEND_TERM_SCREEN_SUBHEADING_3}</strong>
        </span>
      </div>
    </Heading>
  </div>
);
